export default __webpack_public_path__ + "static/media/Element-2.bc3eec2a.png";